<template>
  <v-layout>

    <v-dialog v-bind:value="dialog" width="700" hide-overlay @click:outside="closeModal()"
      transition="dialog-bottom-transition">
      <v-card class="">
        <v-form v-on:submit.prevent="uploadFiles">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeModal()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <!-- Área de drop personalizada -->
          <v-card-text>
            <div class="container-documents mt-5">

              <div class="drop-area" @dragover.prevent @dragenter.prevent @drop.prevent="handleDrop">
                <font-awesome-icon class="download-icon" icon="fa-download" @click="triggerFileInput" />
                <p class="mt-4 mb-0">Suelta los archivos aquí o haz clic para seleccionarlos</p>

                <input type="file" ref="hiddenFileInput" style="display: none" multiple @change="handleFileChange" accept=".pdf, .xls, .xlsx, .doc, .docx, .png, .jpg, .jpeg"/>


                <div v-if="files.length" class="mt-4">
                  <v-list>
                    <v-list-item v-for="(item, index) in files" :key="index">
                      <v-list-item-content>
                        <v-list-item-title class="text-left">{{ item.file.name }}</v-list-item-title>
                        <v-progress-linear v-if="item.status === 'loading'" indeterminate color="primary"
                          size="20"></v-progress-linear>
                      </v-list-item-content>
                      <v-list-item-action class="mt-0 mb-0">


                        <v-icon v-if="item.status === 'success'" color="green">mdi-check-circle</v-icon>
                        <v-icon v-if="item.status === 'error'" color="red">mdi-alert-circle</v-icon>

                        <!-- Botón eliminar (solo si no está cargando) -->
                       
                          <v-icon color="red"  v-if="item.status != 'success' && item.status != 'error'" icon @click="removeFile(index)"
                          :disabled="item.status === 'loading'">mdi-close</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </div>
              </div>

              <!-- Previsualización -->
            </div>
          </v-card-text>
          <v-card-actions >
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeModal()">Cerrar</v-btn>
            <v-btn color="success" text type="submit" :loading="loading" :disabled="btn_disabled">Subir</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";

export default {
  mixins: [ModalGenericMixin],
  props: {
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    formBtn: String,
    selectedFolder: Object,
    legajo_id: [Number, String],
  },
  data() {
    return {
      show: false,
      files: [],
      btn_disabled: false,
    };
  },
  watch: {
    legajo_id: {
      immediate: true,
      handler(newVal) {
        this.legajo_id = newVal;
      }
    },
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
    },
  },
  mounted() { },
  methods: {
    triggerFileInput() {
      this.$refs.hiddenFileInput.click();
    },
    handleFileChange(event) {
      const newFiles = Array.from(event.target.files).map(file => ({
        file,
        status: 'idle' // Inicializamos el estado
      }));

      this.files = [...this.files, ...newFiles];
      event.target.value = null; 
    },

    async uploadFiles() {
      this.btn_disabled = true;

      for (let i = 0; i < this.files.length; i++) {
        const item = this.files[i];
        if (item.status !== 'idle') continue;

        item.status = 'loading';

        try {
          const formData = new FormData();
          formData.append('file', item.file);
          formData.append('name', item.file.name);
          formData.append('legajo_id', this.legajo_id);
          formData.append('folder_id', this.selectedFolder.id);

          await this.service.uploadDocument(formData)
            .then((response) => {
              if (response.status) {
                item.status = 'success';
              } else {
                item.status = 'error';
              }
            })
            .catch(() => {
              item.status = 'error';
            });

        } catch (error) {
          item.status = 'error';
        }
      }
    },

    closeModal() {
      this.$emit("updateDialog", false);
      this.files = [];
      this.btn_disabled = false;
      this.$emit("loadList");
    },
    handleDrop(event) {
      const droppedFiles = Array.from(event.dataTransfer.files).map(f => ({
        file: f,
        status: 'idle'
      }));
      this.files = this.files.concat(droppedFiles);
    },
    handleFileInput(newFiles) {
      const mapped = newFiles.map(f => ({ file: f, status: 'idle' }));
      this.files = [...this.files, ...mapped];
    },
    removeFile(index) {
      this.files.splice(index, 1);
    }
  },
};
</script>
